import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import { InvoiceEntity } from "../../entities/InvoiceEntity";

/**
 * Get Invoice By ID Use Case
 * Retrieves a single invoice by its ID
 */
export class GetInvoiceByIdUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(invoiceId: number): Promise<InvoiceEntity> {
    // if (!invoiceId || invoiceId <= 0) {
    //   throw new Error("Valid invoice ID is required");
    // }

    return await this.repository.getInvoice(invoiceId);
  }
}
